export default "__VITE_ASSET__BcOpf5o1__"